import { render, staticRenderFns } from "./payment-badge.vue?vue&type=template&id=1f6278f3&scoped=true&"
import script from "./payment-badge.vue?vue&type=script&lang=js&"
export * from "./payment-badge.vue?vue&type=script&lang=js&"
import style0 from "./payment-badge.vue?vue&type=style&index=0&id=1f6278f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6278f3",
  null
  
)

export default component.exports